<template>
  <div>
    <v-app-bar
        color="white"
        flat
        dense
      >
        <div style="width:36px;"></div>
        <v-spacer></v-spacer>
          <v-img
            class="shrink mr-2"
            contain
            src="/img/icons/favicon-32x32.png"
            transition="scale-transition"
            alt="Simple Shopping List"
            width=32px
            @click="$router.push({name: 'Home'}).catch(err => {})"
          />
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      cliped
      right
      dark
    >
    <v-container>
      <v-list-item @click="$router.push({name: 'Home'}).catch(err => {});drawer=false">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ホーム</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="$router.push({name: 'EditTodo'}).catch(err => {});drawer=false">
        <v-list-item-icon>
          <v-icon>mdi-pencil-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>リスト作成</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="$router.push({name: 'TodoListView'}).catch(err => {});drawer=false">
        <v-list-item-icon>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>リスト一覧</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="$router.push({name: 'ConfigView'}).catch(err => {});drawer=false">
        <v-list-item-icon>
          <v-icon>mdi-tools</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>アカウント設定</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="$router.push({name: 'LP', query: {from: 'i'}}).catch(err => {});drawer=false">
        <v-list-item-icon>
          <v-icon>mdi-information-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>本アプリについて</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-container>
    </v-navigation-drawer>
  </div>
</template>
<script>

// @ is an alias to /src
export default {
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    test() {
      alert('meHead!!')
    }
  }
}
</script>